import { ClienteEstado } from 'src/utils/enums/ClienteEstado';
import { ClienteFormState } from './types';
import { colorMapping } from 'src/utils/enums/ClienteEstado';

import {
  darDeBajaClienteF,
  darDeAltaClienteF,
  verificarClienteF,
} from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ClienteFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
};

const formSlice = createSlice({
  name: 'clienteForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },

    setFormStatusBorrador(state) {
      state.status = {
        id: ClienteEstado.Borrador,
        text: ClienteEstado[ClienteEstado.Borrador].toUpperCase(),
        color: colorMapping[ClienteEstado.Borrador],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        darDeBajaClienteF: {
          visible: false,
          disabled: false,
          tooltip: 'Pasar el cliente a estado "Baja".',
        },
        darDeAltaClienteF: {
          visible: false,
          disabled: false,
          tooltip: 'Pasar el cliente a estado "Alta".',
        },
        verificarClienteF: {
          visible: true,
          disabled: false,
          tooltip: 'Pasar el cliente a estado "Verificado".',
        },
      };
    },

    setFormStatusBaja(state) {
      state.status = {
        id: ClienteEstado.Baja,
        text: ClienteEstado[ClienteEstado.Baja].toUpperCase(),
        color: colorMapping[ClienteEstado.Baja],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        darDeBajaClienteF: {
          visible: false,
          disabled: false,
          tooltip: 'Pasar el cliente a estado "Baja".',
        },
        darDeAltaClienteF: {
          visible: true,
          disabled: false,
          tooltip: 'Pasar el cliente a estado "Alta".',
        },
        verificarClienteF: {
          visible: true,
          disabled: true,
          tooltip: 'Pasar el cliente a estado "Verificado".',
        },
      };
    },
    setFormStatusVerificado(state) {
      state.status = {
        id: ClienteEstado.Verificado,
        text: ClienteEstado[ClienteEstado.Verificado].toUpperCase(),
        color: colorMapping[ClienteEstado.Verificado],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        darDeBajaClienteF: {
          visible: true,
          disabled: false,
          tooltip: 'Pasar el cliente a estado "Baja".',
        },
        darDeAltaClienteF: {
          visible: true,
          disabled: false,
          tooltip: 'Pasar el cliente a estado "Alta".',
        },
        verificarClienteF: {
          visible: false,
          disabled: false,
          tooltip: 'Pasar el cliente a estado "Verificado".',
        },
      };
    },
    setFormStatusAlta(state) {
      state.status = {
        id: ClienteEstado.Alta,
        text: ClienteEstado[ClienteEstado.Alta].toUpperCase(),
        color: colorMapping[ClienteEstado.Alta],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        darDeBajaClienteF: {
          visible: true,
          disabled: false,
          tooltip: 'Pasar el cliente a estado "Baja".',
        },
        darDeAltaClienteF: {
          visible: false,
          disabled: false,
          tooltip: 'Pasar el cliente a estado "Alta".',
        },
        verificarClienteF: {
          visible: true,
          disabled: false,
          tooltip: 'Pasar el cliente a estado "Verificado".',
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(darDeBajaClienteF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(darDeBajaClienteF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(darDeAltaClienteF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(darDeAltaClienteF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(verificarClienteF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(verificarClienteF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });
  },
});
// Selectors

export const selectFormStatus = (state: RootState) => state.cliente.form.status;

export const selectDarDeBajaClienteF = (state: RootState) =>
  state.cliente.form.actions?.darDeBajaClienteF;

export const selectDarDeAltaClienteF = (state: RootState) =>
  state.cliente.form.actions?.darDeAltaClienteF;

export const selectVerificarClienteF = (state: RootState) =>
  state.cliente.form.actions?.verificarClienteF;

export const selectGuardar = (state: RootState) =>
  state.cliente.form.actions?.guardar;

// Export actions
export const {
  resetForm,
  setFormStatusBorrador,
  setFormStatusBaja,
  setFormStatusVerificado,
  setFormStatusAlta,
} = formSlice.actions;

export default formSlice.reducer;
